import React, { useEffect, useContext, useState } from "react";
import { SuperSEO } from "react-super-seo";
import axios from "axios";
import {
  Accordion,
  Card,
  Carousel,
  Col,
  ListGroup,
  Row,
} from "react-bootstrap";
import PsContext from "../../../context";

import { ServiceUrl } from "../../../utils/serviceUrl";
import {
  customSorting,
  DB_POSTFIX,
  getFileLiveUrl,
  groupByMultiple,
  LOADER_LOGO,
  upperCase,
} from "../../../utils";
import { COURSE_TYPE_SORT_ORDER } from "../../../utils/data";

const SyllabusList = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);

  const deptId = props.match.params.id;
  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);

  const [accordianKey, setAccordianKey] = useState("ug");

  useEffect(() => {
    setDataList([]);
    loadData();
  }, [props.pageId]);

  const loadData = () => {
    setLoader(true);

    axios
      .get(
        ServiceUrl.DEPT.FILES +
          "?row_type=syllabus&academic_department=" +
          deptId +
          "&sadb=" +
          DB_POSTFIX
      )
      .then((res) => {
        if (res["data"].status == "1") {
          let d = customSorting(
            res["data"].data,
            COURSE_TYPE_SORT_ORDER,
            "course_type"
          );
          let m = groupByMultiple(d, function (obj) {
            return [obj.course_type];
          });
          setDataList(d);
          setDataView(m);
          setAccordianKey(m[0].course_tye);
        }
        setLoader(false);
      });
  };

  const fileList = (items) => {
    return items.map((item) => (
      <div className="py-3 border-bottom">
        <a
          href={getFileLiveUrl(item.file_path)}
          target="_blank"
          className="text-dark"
        >
          {item.file_title}
          <span className="float-end">
            <i className="fa-solid fa-up-right-from-square"></i>
          </span>
        </a>
      </div>
    ));
  };

  const batchList = (items) => {
    items = groupByMultiple(items, function (obj) {
      return [obj.batch];
    });
    return items.map((item) => (
      <Accordion>
        <Accordion.Header eventKey={item[0].batch}>
          <b>
            <i>{item[0].batch}</i>
          </b>
        </Accordion.Header>
        <Accordion.Body>{fileList(item)}</Accordion.Body>
      </Accordion>
    ));
  };

  return (
    <>
      {loader && (
        <center className="py-5">
          <img src={LOADER_LOGO.default} />
        </center>
      )}

      {dataList.length > 0 && (
        <div>
          <h4 className="text-center mb-4">Syllabus</h4>
          <Accordion defaultActiveKey={accordianKey}>
            {dataView.map((item, i) => {
              return (
                <Accordion.Item eventKey={item[0].course_type}>
                  <Accordion.Header className="fw-bold">
                    <b>{upperCase(item[0].course_type)}</b>
                  </Accordion.Header>
                  <Accordion.Body>{batchList(item)}</Accordion.Body>
                </Accordion.Item>
              );
            })}
          </Accordion>
        </div>
      )}
    </>
  );
};

export default SyllabusList;
